import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Category from '@/views/Category.vue'
import TeamInfo from '@/views/TeamInfo.vue'
import MyCenter from '@/views/Center.vue'
import Review from '@/components/TeamCertification/Review.vue' //团队认证审核
import InvoiceInfo from '@/components/MyCenter/InvoiceInfo.vue' //发票信息填写
import invoiceDetail from '@/components/MyCenter/invoiceDetail.vue' //发票详情
import FitReservation from '@/components/TicketReservation/FitReservation.vue' //散客预约填写预约信息
import ConfirmOrder from '@/components/TicketReservation/ConfirmOrder.vue' //散客预约确认订单信息
import ReservationSuccess from '@/components/TicketReservation/ReservationSuccess.vue' //散客预约订单预约成功
import ReservationInfo from '@/components/TeamReservation/ReservationInfo.vue' //团队预约填写预约信息
import TeamConfirmOrder from '@/components/TeamReservation/TeamConfirmOrder.vue' //团队预约确认订单信息
import ReservationReview from '@/components/TeamReservation/ReservationReview.vue' //团队预约订单预约待审核
import OrderReview from '@/components/TeamReservation/OrderReview.vue' //团队订单待审核订单详情
import TeamUnused from '@/components/TeamReservation/Unused.vue' //团队订单待使用订单详情
import TeamUnPay from '@/components/TeamReservation/UnPay.vue' //团队订单待支付订单详情
import TeamUsed from '@/components/TeamReservation/Used.vue' //团队订单已使用订单详情
import FITUnused from '@/components/TicketReservation/Unused.vue' //散客订单待使用订单详情
import Used from '@/components/TicketReservation/Used.vue' //散客订单已使用订单详情
import UnPay from '@/components/TicketReservation/UnPay.vue' //散客订单待支付订单详情
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

import { checkToken } from '@/utils/http'
Vue.use(Router)
const router = new Router({
	routes: [{
			path: '/',
				component: Login,
				meta: {
					currentTab: 0
				},
	},{
		path: '/Home',
		component: Home,
		meta:{
			currentTab: 0
		},
		children: [{
				path: '/',
				name: 'ReservationInfo',
				component: ReservationInfo,
				meta: {
					keepAlive: true,
					currentTab: 0
				},

			}, {
				path: '/Category',
				name: 'Category',
				component: Category,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/TeamInfo',
				name: 'TeamInfo',
				component: TeamInfo,
				meta: {
					keepAlive: true,
					currentTab: 1
				},
			}, {
				path: '/MyCenter',
				name: 'MyCenter',
				component: MyCenter,
				meta: {
					keepAlive: true,
					currentTab: 2
				},
			}, {
				path: '/FitReservation',
				name: 'FitReservation',
				component: FitReservation,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/ConfirmOrder',
				name: 'ConfirmOrder',
				component: ConfirmOrder,
				meta: {
					keepAlive: true
				},
			}, {
				path: '/ReservationSuccess',
				name: 'ReservationSuccess',
				component: ReservationSuccess,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/Review',
				name: 'Review',
				component: Review,
				meta: {
					keepAlive: false,
					currentTab: 1
				},
			}, {
				path: '/InvoiceInfo',
				name: 'InvoiceInfo',
				component: InvoiceInfo,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			},
			{
				path: '/invoiceDetail',
				name: 'invoiceDetail',
				component: invoiceDetail,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			},
			{
				path: '/TeamConfirmOrder',
				name: 'TeamConfirmOrder',
				component: TeamConfirmOrder,
				meta: {
					keepAlive: false,
					currentTab: 0
				},
			}, {
				path: '/ReservationReview',
				name: 'ReservationReview',
				component: ReservationReview,
				meta: {
					keepAlive: false,
					currentTab: 0
				},
			}, {
				path: '/OrderReview',
				name: 'OrderReview',
				component: OrderReview,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			}, {
				path: '/TeamUnused',
				name: 'TeamUnused',
				component: TeamUnused,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			}, {
				path: '/FITUnused',
				name: 'FITUnused',
				component: FITUnused,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/Used',
				name: 'Used',
				component: Used,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/UnPay',
				name: 'UnPay',
				component: UnPay,
				meta: {
					keepAlive: false
				},
			}, {
				path: '/TeamUnPay',
				name: 'TeamUnPay',
				component: TeamUnPay,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			}, {
				path: '/TeamUsed',
				name: 'TeamUsed',
				component: TeamUsed,
				meta: {
					keepAlive: false,
					currentTab: 2
				},
			},
		]
	}]
})
// 路由前置守卫
router.beforeEach((to, from, next) => {
    if(to.path !== '/') {
    checkToken().then(res=>{
        if(res.code !== 0){
            localStorage.clear()
            next('/')
        }else{
            if (to.name == 'TeamInfo' && localStorage.getItem('isExamine') == 1) {
                // 路由等于TeamInfo时，判断是否提交团队认证，提交则跳审核页面，否则跳填写认证信息  isUpdate为true时表示点击的重新提交，执行跳转
                let isUpdate = to.params != '' ? to.params.isUpdate : false
                if (isUpdate) {
                    next()
                } else {
                    next('Review');
                }
            } else {
                next()
            }
        }
    })
    }else{
        next()
    }



	//第一个参数to，包含的内容是切换后的路由对象，也就是跳转后的路由对象
	//第二个参数from，包含的内容的是切换前的路由对象，也就是跳转前的路由对象
	//第三个参数next()，是否往下执行，执行的话，如果不写的话路由就不会跳转，操作将会终止

})
export default router
